import { TrackJS } from 'trackjs';
import { call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { RealEstateLevel } from 'utils/entities';
import { queryData } from './apiService';
import { LoadType } from './apiService/types';
import { fetchSoldDealBannerDataAction, resetSoldDealBannerDataAction } from 'store/state/app/actions';
import { resetDomainData } from 'store/state/domainData/actions';


export function* fetchSoldDealBannerData(action: ReturnType<typeof fetchSoldDealBannerDataAction>) {
  const { agentId, officeId } = action.payload;

  yield fork(queryData, { loadType: LoadType.GetPublicRealEstateAgentById, meta: { variables: { agentId, level: RealEstateLevel.Public } } });

  try {
    yield call(queryData, { loadType: LoadType.GetPublicRealEstateOfficeById, meta: { variables: { officeId, level: RealEstateLevel.Public } } });
  }
  catch (error) {
    yield put(resetDomainData({ loadType: LoadType.GetPublicRealEstateOfficeById }));
    TrackJS.track([ 'Failed to fetch office data for closed deal banner', error ]);
  }
}

export function* resetSoldDealBannerData() {
  yield put(resetDomainData({ loadType: LoadType.GetPublicRealEstateAgentById }));
  yield put(resetDomainData({ loadType: LoadType.GetPublicRealEstateOfficeById }));
}

export function* fetchSoldDealBannerDataWatcher () {
  yield takeLatest(fetchSoldDealBannerDataAction, fetchSoldDealBannerData);
  yield takeEvery(resetSoldDealBannerDataAction, resetSoldDealBannerData);
}
